'use client'
import { useMemo, type FC } from 'react'
import styled from 'styled-components'
import { Link } from '../base/Link'
import { mq, vw, createUnderlineMiddle, font12 } from '@/styles'
import type { TypeCmsModernImage } from '@/schema'
import { Figure } from '../base/Figure'
import { motion } from 'motion/react'
import { useParams } from 'next/navigation'
export interface TypeSectionHomeIntro {
  data : {
    title: {
      [key: string]: string
    }
    link?: string
    media: TypeCmsModernImage
  }[]

}

const getLinks = (data, lang) => data.map((el, idx) => {
  return (
    <li key={idx}>
      <Link href={`${el.link || '#'}`}>
        <Figure media={el.media} />
        <span>{el.title?.[lang]}</span>
      </Link>
    </li>
  )
})

export const SectionHomeIntro: FC<TypeSectionHomeIntro> = ({ data }) => {
  const { lang } = useParams()
  const Links = useMemo(() => getLinks(data, lang ?? 'en'), [data, lang])

  return (
    <Section>
      <ul>
        {Links}
      </ul>
    </Section>
  )
}

const Section = styled(motion.section)`
  grid-column: 1 / span 6;
  margin: 0 auto ${vw(100, 'mobile')};
  width: 100%;

  ${mq.greaterThan('tablet')} {
    grid-column: 1 / span 12;
    margin: 0 auto ${vw(150, 'desktop')};
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    height: auto;
    width: 100%;

    ${mq.greaterThan('tablet')} {
      flex-wrap: nowrap;
      flex-direction: row;
    }


    li {
      border-left: 1px solid rgba(0,0,0,0.1);
      border-bottom: 1px solid rgba(0,0,0,0.1);
      height: ${vw(245, 'mobile')};
      width: 50%;
      padding: unset;

      ${mq.greaterThan('tablet')} {
        border-bottom: unset;
        height: unset;
        width: 25%;
        padding: ${vw(50, 'desktop')} 0;
      }


      &:first-of-type {
        border-left: none;
        width: 50%;
        padding-right: ${vw(10, 'mobile')};

        ${mq.greaterThan('tablet')} {
          width: 25%;
          padding-right: 0
        }
      }

      &:nth-of-type(2) {
       padding-left: ${vw(10, 'mobile')};

        ${mq.greaterThan('tablet')} {
         padding-left: 0
        }
      }

      &:nth-of-type(3) {
        border-left: none;
        border-bottom: none;
        padding-right: ${vw(10, 'mobile')};

        ${mq.greaterThan('tablet')} {
          border-left: 1px solid rgba(0,0,0,0.1);
          padding-right: 0
        }
      }

      &:nth-of-type(4) {
        border-bottom: none;
        padding-left: ${vw(10, 'mobile')};

        ${mq.greaterThan('tablet')} {
         padding-left: 0
        }
      }

      > a {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;

        span {
          ${createUnderlineMiddle({})}
        }

        &:hover {
          span {
            background-size: 100% 1px;
          }
        }
        > figure {
          height: ${vw(150, 'mobile')};
          margin-bottom: ${vw(20, 'mobile')};
          mix-blend-mode: multiply;
          width: 100%;
          z-index: 1;

          ${mq.greaterThan('tablet')} {
            height: ${vw(243, 'desktop')};
            margin-bottom: ${vw(30, 'desktop')};
            min-width: ${vw(308, 'desktop')};
            width: 92%;
          }

          img {
            object-fit: contain;
            mix-blend-mode: multiply;
            z-index: 1;
          }
        }

        > span {
          ${font12(true)}
          line-height: 185%;
          text-transform: uppercase;

          ${mq.greaterThan('tablet')} {
            ${font12(false)}
            line-height: 185%;
          }
        }
      }

    }
  }
`
